module.exports = __webpack_public_path__ + "img/cloud06.b942343b.png";